// Small shared helpers for the onboarding form builder tabs and modals.

export const KIND_BADGE = {
  Question: 'light-primary',
  Notice: 'light-warning',
  Upload: 'light-info',
}

export const KIND_LABEL = {
  Question: 'Question',
  Notice: 'Notice',
  Upload: 'Upload',
}

export const ACK_BADGE = {
  Tick: 'light-secondary',
  Signature: 'light-warning',
}

export const ACK_LABEL = {
  Tick: 'Tick box',
  Signature: 'Name + signature',
}

export const OPTION_INPUT_TYPES = ['radio', 'select', 'checkboxes']

export function kindBadge(kind) {
  return KIND_BADGE[kind] || 'light-secondary'
}

export function kindLabel(kind) {
  return KIND_LABEL[kind] || kind || ''
}

export function ackBadge(mode) {
  return ACK_BADGE[mode] || 'light-secondary'
}

export function ackLabel(mode) {
  return ACK_LABEL[mode] || mode || ''
}

export function hasOptions(inputType) {
  return OPTION_INPUT_TYPES.indexOf(inputType) !== -1
}

// API error → message string for toasts.
export function apiError(err, fallback) {
  return (err && err.response && err.response.data && err.response.data.message)
    || fallback
    || 'An error occurred.'
}

// Label for a scope value from the `scopes` catalogue ({value,label}).
export function scopeLabel(scopes, value) {
  const hit = (scopes || []).find(s => s.value === value)
  return hit ? hit.label : (value || '')
}

// Section title by key from the `sections` catalogue.
export function sectionTitle(sections, key) {
  const hit = (sections || []).find(s => s.Key === key)
  return hit ? hit.Title : (key || '')
}

export function plural(count, singular, pluralWord) {
  const n = Number(count) || 0
  return `${n} ${n === 1 ? singular : (pluralWord || `${singular}s`)}`
}

// "one per line" textarea → clean array of strings.
export function linesToArray(text) {
  return String(text || '')
    .split(/\r?\n/)
    .map(v => v.trim())
    .filter(v => v.length)
}

export function arrayToLines(arr) {
  return (arr || []).join('\n')
}

// "a, b, c" → ['a','b','c'].
export function csvToArray(text) {
  return String(text || '')
    .split(',')
    .map(v => v.trim())
    .filter(v => v.length)
}

let uid = 0
export function nextUid() {
  uid += 1
  return uid
}
